import React from 'react'
import cx from 'classnames'
import { Button, Modal, ToolTip } from '@driftt/tide-core-legacy'
import { Driftiwyg } from '@driftt/tide-driftiwyg-legacy'
import DelayTime from './DelayTime'
import './style.styl'
import { humanizeDelay } from './utils'


const TemplateOption = ({ displayValue, selected, onClick }) => <p
  className={cx("template-option", { selected })}
  onClick={onClick}>
  {displayValue}
</p>

class EmailTemplateModal extends React.Component {
  constructor(props) {
    super(props)
    const { templateOptions } = this.props
    this.state = {
      selectedOption: _.head(templateOptions)
    }
  }
  render() {
    const {
      isOpen,
      onClose,
      onSave,
      onCancel,
      editingAssistantAgentSettings,
      settingName,
      selectedSettingName,
      selectSetting,
      settingTemplateOptions = [],
      hasDelayEditing = true,
      delayTime,
      onDelayEdit,
      initialEmailSubject,
      onSubjectEdit,
      initialEmailBody,
      onBodyEdit,
      sendTestEmail,
      sendTestEmailPending,
      assistantConfigHasEdits,
      personalizationTags = {}
    } = this.props
    const hasTemplateOptions = !!settingTemplateOptions.length
    
    const title = settingName === 'MEETING_CONFIRMATION'
      ? "Customize your meeting confirmation message"
      : "Customize your meeting reminder message"

    const delayCopy = settingName === 'MEETING_CONFIRMATION'
      ? "after a meeting is booked."
      : "before your meeting."

    const templateOptionsComponents = hasTemplateOptions && _.map(settingTemplateOptions, (optionName, i) => {
      return <TemplateOption
        key={`${optionName}-${i}`}
        displayValue={humanizeDelay(editingAssistantAgentSettings.getIn([optionName, 'delayTime'], 0))}
        selected={selectedSettingName === optionName}
        onClick={() => selectSetting(optionName)} />
    })

    const SendEmailButton = <Button
      disabled={assistantConfigHasEdits || sendTestEmailPending }
      loading={sendTestEmailPending}
      className="test-email-button"
      type="subtle"
      size="small"
      onClick={sendTestEmail}>
      Send test email
      </Button>

    const testEmailButton = assistantConfigHasEdits ? 
      (
        <ToolTip flow="left" component={<span>Save your changes to send a test email!</span>} className="overwrite-info-button">
          {SendEmailButton}
        </ToolTip>
      ) : (
        <ToolTip flow="left" component={<span>Meeting information will be based <br />on your default meeting type</span>} className="overwrite-info-button">
          {SendEmailButton}
        </ToolTip>
      )
    
    const { meeting, company, user } = personalizationTags

    return <Modal
      className="meeting-email-template-modal"
      open={isOpen}
      size="medium"
      onClose={onClose}
    >
      <div className="meeting-email-template-modal-content-wrapper">
        <div className="meeting-email-template-modal-content">
          <div className="meeting-email-template-modal-header"><h2>{title}</h2></div>
          {!!hasTemplateOptions && <div className="template-options-wrapper">
            {templateOptionsComponents}
          </div>
          }
          <div className="delay-and-send-wrapper">
            { hasDelayEditing && <div className="meeting-email-template-modal-delay-editor">
              <DelayTime
                value={delayTime}
                onUpdate={onDelayEdit}
                delayCopy={delayCopy}
                selectedSettingName={selectedSettingName}
                /> 
            </div>}
            {testEmailButton}
          </div>
          <div className={cx("meeting-email-template-body", { 'has-template-options': hasTemplateOptions })}>
            <div className="template-label-option-wrapper">
              <p>Email Subject</p>
              <Driftiwyg
                className="email-subject-editor"
                placeholder="Enter your email subject here!"
                editorState={initialEmailSubject}
                onChange={(value) => onSubjectEdit(value)}
                companyTagList={company}
                meetingTagList={meeting}
                userTagList={user}
                toolbarOptions={['emoji', 'tag']}
                v2
              />
            </div>
            <div className="template-label-option-wrapper">
              <p>Email Template</p>
              <Driftiwyg
                className="email-body-editor"
                placeholder="Enter your email template here!"
                editorState={initialEmailBody}
                onChange={(value) => onBodyEdit(value)}
                companyTagList={company}
                meetingTagList={meeting}
                userTagList={user}
                toolbarOptions={['bold', 'italic', 'underline', 'link', 'emoji', 'image', 'tag']}
                v2
              />
            </div>
          </div>
        </div>
      </div>
      <div className="meeting-email-template-modal-button-section-wrapper">
        <div className="meeting-email-template-modal-button-section">
          <Button
            type="primary"
            size="medium"
            onClick={() => {
              return onSave()
            }}
          >
            Save
              </Button>
          <Button
            type="tertiary"
            onClick={() => {
              // optimize this later
              if (assistantConfigHasEdits) {
                if (window.confirm("Are you sure you want to leave this page? You will lose any unsaved changes.")) {
                  onCancel()
                  return onClose()
                }
              } else {
                onCancel()
                return onClose()
              }
            }}
          >
            Cancel
              </Button>
        </div>
      </div>
    </Modal>
  }
}

export default EmailTemplateModal



// WEBPACK FOOTER //
// ./src/scripts/components/EmailTemplateModal/component.js